import Vue from "vue";
import ViewUI from "view-design";
import en from "view-design/dist/locale/en-US";
import VueI18n from "vue-i18n";
import zh from "view-design/dist/locale/zh-CN";
import App from "./App";
import router from "./router";
import store from "./store";
import "view-design/dist/styles/iview.css";
import "./style/public.less";
import "@mdi/font/css/materialdesignicons.min.css";
import AxiosJs from "./config/axios";
import "@/config/AWS-S3";

Vue.use(VueI18n);
Vue.locale = () => {};
const messages = {
  en: { message: "hello", ...en },
  zh: { message: "你好", ...zh },
};
const i18n = new VueI18n({
  locale: "en", // set locale
  messages, // set locale messages
});

Vue.use(ViewUI);
Vue.config.productionTip = false;
Vue.prototype.$http = AxiosJs;

// 使用APOLLO配置 ARUP版 本地联调使用
// if (process.env.NODE_ENV === "development") {
//   window.APOLLO_API = "https://dev.neuroncloud.ai/apollo";
// }
window.myVue = new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

// if (window.APOLLO_API) {
//   initConfigs().then(({ apiConfig, publicKey }) => {
//     window.API_CONFIG = apiConfig;
//     // store.dispatch("updateAWSConfig", awsConfig);
//     store.dispatch("updateApiConfig", apiConfig);
//     store.commit("updatePublicKey", publicKey);
//     window.myVue = new Vue({
//       i18n,
//       router,
//       store,
//       render: (h) => h(App),
//     }).$mount("#app");
//   });
// }
